module.exports = __webpack_public_path__ + "static/media/Resume_Sabesan_Sathananthan.37d7d34a.pdf";